import { combineReducers } from '@reduxjs/toolkit';

import { appSettingsReducer } from '@app/model/app-settings';
import { callsParkingReducer, callsReducer, deviceSettingsReducer } from '@features/call';
import { authReducer } from '@entities/auth/model/auth-slice';
import { notificationsReducer } from '@entities/notifications';
import { sidePanelReducer } from '@widgets/side-panel';

export const rootReducer = combineReducers({
	appSettings: appSettingsReducer,
	auth: authReducer,
	notifications: notificationsReducer,
	calls: callsReducer,
	callsParking: callsParkingReducer,
	deviceSettings: deviceSettingsReducer,
	sidePanel: sidePanelReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
